import { render, staticRenderFns } from "./testingPhoneInput.vue?vue&type=template&id=2fac548a&"
import script from "./testingPhoneInput.vue?vue&type=script&lang=js&"
export * from "./testingPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports